import { z } from "zod";

export const getSivDataByRegistrationNumberResponseSchema = z.object({
  model: z.string(),
  modelVersion: z.string(),
  brand: z.string(),
  cylinder: z.number().int().nullable(),
  year: z.number().int(),
  energy: z.string(),
  vehicleBody: z.string(),
});

export type GetSivDataByRegistrationNumberResponse = z.infer<
  typeof getSivDataByRegistrationNumberResponseSchema
>;
